import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, HttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from './core/i18n/multi-translate-http-loader';
import { TranslationService } from './core/services/translation-service';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';

import {
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
} from '@azure/msal-angular';

import { MSALInstanceFactory, MSALGuardConfigFactory } from './core/auth/msal.config';
import { AuthService } from './core/auth/auth-service';
import { timeZoneInterceptor } from './core/interceptors/timezone.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { authErrorInterceptor } from './core/interceptors/authError.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor, authErrorInterceptor, timeZoneInterceptor]),
    ),
    provideTranslateService({
      fallbackLang: 'en',
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) =>
          new MultiTranslateHttpLoader(http, ['/assets/i18n/common', '/assets/i18n/shell']),
        deps: [HttpClient],
      },
    }),
    provideDateFnsAdapter(),
    provideAppInitializer(async () => {
      // translate
      const translateService = inject(TranslateService);
      const translationService = inject(TranslationService);
      translationService.init(translateService);

      const authService = inject(AuthService);
      await authService.initializeMsal();
    }),

    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
